import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import App from './App';
import Login from './views/login/Login';
import Logout from './views/login/Logout';
import Home from './views/home/Home';
import MenuGroup from './views/menu_group/MenuGroup';
import './index.css';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Menu from './views/menu/Menu';
import MenuMatrice from './views/menu/MenuMatrice';
import UserList from './views/user/UserList';
import UserDetail from './views/user/UserDetail';
import Category from './views/category/Category';
import Error from './views/Error';
import Brand from './views/brand/Brand';
import Attribute from './views/category/Attribute';
import CategoryList from './views/category/CategoryList';
import CategoryDetail from './views/category/CategoryDetail';
import AttributeList from './views/attribute/AttributeList';
import AttributeDetail from './views/attribute/AttributeDetail';
import BrandList from './views/brand/BrandList';
import BrandDetail from './views/brand/BrandDetail';
import CategoryTree from './views/category/CategoryTree';
import ProductList from './views/product/ProductList';
import ProductDetail from './views/product/ProductDetail';
import Banner from './views/banner/Banner';
import BannerDetail from './views/banner/BannerDetail';
import Policy from './views/policy/Policy';
import PolicyDetail from './views/policy/PolicyDetail';
import PolicyList from './views/policy/PolicyList';
import AttributeChoiceList from './views/attribute_choice/AttributeChoiceList';
import AttributeChoiceDetail from './views/attribute_choice/AttributeChoiceDetail';
import ShipmentList from './views/shipment/ShipmentList';
import CategoryDetailPage from './views/category/CategoryDetailPage';
import BrandDetailPage from './views/brand/BrandDetailPage';
import ListingList from './views/listing/ListingList';
import ListingDetail from './views/listing/ListingDetail';
import BankIncomingTxnList from './views/bank/BankIncomingTxnList';
import SysJobRunList from './views/sysjob/SysJobRunList';
import DeliveryZoneList from './views/deliveryzone/DeliveryList';
import WalletWithdrawalRequestList from './views/wallet/WalletWithdrawalRequestList';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const AppContext = createContext("Abox");
const appName: string = "Abox";

root.render(
  <React.StrictMode>
    <AppContext.Provider value={appName}>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route element={<App />}>
              <Route path="/home" element={<Home />}></Route>
              <Route path="/menu-group/:menuGroupId" element={<MenuGroup />}></Route>
              <Route path="/menu-group" element={<MenuGroup />}></Route>
              <Route path="/menu" element={<Menu />}></Route>
              <Route path="/menu-matrices" element={<MenuMatrice />}></Route>
              <Route path="/user" element={<UserList />}></Route>
              <Route path="/user/:phoneNo" element={<UserDetail />}></Route>
              <Route path="/category" element={<Category />}></Route>
              <Route path="/category/:categoryId" element={<CategoryDetailPage />}></Route>
              <Route path="/category/old/:categoryId" element={<CategoryDetail />}></Route>
              <Route path="/category-list" element={<CategoryList />}></Route>
              <Route path="/category-tree" element={<CategoryTree />}></Route>
              <Route path="/attribute" element={<Attribute />}></Route>
              <Route path="/attribute/:attributeId" element={<AttributeDetail />}></Route>
              <Route path="/attribute-list" element={<AttributeList />}></Route>
              <Route path="/brand" element={<Brand />}></Route>
              <Route path="/brand/old/:brandId" element={<BrandDetail />}></Route>
              <Route path="/brand/:brandId" element={<BrandDetailPage />}></Route>
              <Route path="/brand-list" element={<BrandList />}></Route>
              <Route path="/product-list" element={<ProductList />}></Route>
              <Route path="/product/:productId" element={<ProductDetail />}></Route>
              <Route path="/banner" element={<Banner />}></Route>
              <Route path="/banner/:bannerId" element={<BannerDetail />}></Route>
              <Route path="/policy" element={<Policy />}></Route>
              <Route path="/policy/:policyId" element={<PolicyDetail />}></Route>
              <Route path="/policy-list" element={<PolicyList />}></Route>
              <Route path="/attribute-choice-list" element={<AttributeChoiceList />}></Route>
              <Route path="/attribute-choice/:choiceId" element={<AttributeChoiceDetail />}></Route>
              <Route path="/delivery" element={<ShipmentList />}></Route>
              <Route path="/listing-list" element={<ListingList />}></Route>
              <Route path="/listing/:listingId" element={<ListingDetail />}></Route>
              <Route path="/bank-txn-list" element={<BankIncomingTxnList />}></Route>
              <Route path="/sys-job-run-list" element={<SysJobRunList />}></Route>
              <Route path="/delivery-zone" element={<DeliveryZoneList />}></Route>
              <Route path="/wallet/withdrawal-request" element={<WalletWithdrawalRequestList />}></Route>
              <Route path="/logout" element={<Logout />}></Route>
            </Route>
            <Route path="/error" element={<Error />}></Route>
            <Route path="/" element={<Navigate replace to="/login" />} />
            <Route path="/login" element={<Login />}></Route>
          </Routes>
        </BrowserRouter>
      </Provider>
    </AppContext.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();